import React, { useState } from "react";
import useMediaQueries from "hooks/useMediaQueries.js";
import AnimationContainer from "../AnimationContainer/AnimationContainer.js";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import { useMail } from "contexts/mailContext/mailContext.js";

const CollectionsElement = ({ itemId, showList }) => {
  const {
    getCollectionsList,
    getCollectionsData,
    isFileInCollection,
    addFilesToCollection,
    removeFilesFromCollection,
  } = useMail();

  return (
    <AnimationContainer
      animationOn={showList}
      animationClassName="hover-item-fade"
    >
      <div
        className="collections-list-container"
        onClick={(e) => e.stopPropagation()}
      >
        {getCollectionsList().map((item) => {
          const elem = getCollectionsData()[item];
          return (
            <div className={"collection-select-element"} key={item}>
              <div className="collection-name">{elem.collectionName}</div>
              <div
                className="collection-action"
                onClick={(e) => e.stopPropagation()}
              >
                {isFileInCollection(item, itemId) ? (
                  <Tooltip
                    id={"deleteFromCollectionIcon" + item}
                    tooltipTextKey="delete-from-collection-icon-tooltip-text"
                  >
                    <Icon
                      name="trash-solid"
                      white
                      small
                      onClick={() => {
                        removeFilesFromCollection(item, [itemId]);
                      }}
                    />
                  </Tooltip>
                ) : (
                  <Tooltip
                    id={"addToCollectionIcon" + item}
                    tooltipTextKey="add-to-collection-icon-tooltip-text"
                  >
                    <Icon
                      name="plus"
                      white
                      small
                      onClick={() => {
                        addFilesToCollection(item, [itemId]);
                      }}
                    />
                  </Tooltip>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </AnimationContainer>
  );
};

const CollectionFileAction = ({ itemId }) => {
  const { getCollectionsList } = useMail();

  const [showList, setShowList] = useState(false);

  return getCollectionsList().length > 0 ? (
    <>
      <Tooltip tooltipTextKey="add-to-collection-icon-tooltip-text">
        <div
          className="collection-holder"
          onClick={(e) => {
            setShowList((prev) => !prev);
            e.stopPropagation();
          }}
        >
          <Icon name="collections" white small />
        </div>
      </Tooltip>
      <CollectionsElement showList={showList} itemId={itemId} />
    </>
  ) : null;
};

export default CollectionFileAction;
